import type { ImageSanityProps } from './ImageSanity.types';
import { useSanityImageUrl } from './getSanityImageUrl';
import { parseSanityImageObject } from './parseSanityImageObject';

/**
 * Displays a transformed Sanity Image. Uses a `img` element to maintain intrinsic
 * sizing.
 */
export const ImageSanity = ({ format, height, imageObject, quality, styles, width, testId }: ImageSanityProps) => {
  const sanityImageObject = parseSanityImageObject(imageObject);
  const imageUrl = useSanityImageUrl({
    format,
    height,
    imageObject: sanityImageObject,
    quality,
    width,
  });

  return (
    <img
      src={imageUrl}
      alt={imageObject.alt}
      width={width}
      height={height}
      style={{
        height: '100%',
        objectFit: 'cover',
        width: '100%',
        ...styles,
      }}
      data-testid={testId}
    />
  );
};
